import { useEffect, useState } from 'react';
import { logger } from '@fiverr-private/obs';
import { getBusinessTeamMembers as getBusinessTeamMembersApi, IMember } from '../../api';
import { IUseAdminInfo } from './types';

export const useAdminInfo = (): IUseAdminInfo => {
    const [adminInfo, setAdminInfo] = useState<IMember>();

    useEffect(() => {
        const getBusinessTeamMembers = async (): Promise<void> => {
            try {
                const data = await getBusinessTeamMembersApi();

                const adminInfo = data.membersList.find((member) => member.role === 'admin');

                setAdminInfo(adminInfo);
            } catch (error) {
                logger.error(`Failed to get business team members.`, { error });
            }
        };

        getBusinessTeamMembers();
    }, []);

    return { adminInfo };
};
